// @flow
/* global document */

import * as React from 'react';

import { useLocation } from 'react-router-dom';
import { useResizeObserver } from 'usehooks-ts';

import { useLayoutEffect } from 'src/hooks/useLayoutEffect';
import { useScrollBottom } from 'src/hooks/useScrollBottom';

import { ConfirmationRemoveCart } from './ConfirmationRemoveCart';
import CartSummaryButton from './components/CartSummaryButton';
import Contracts from './components/Contracts';
import { Total } from './components/Total';

import styles from './CartSummary.scss';

export function CartSummary(): React.MixedElement | null {
  const location = useLocation();

  const [deleteCart, setDeleteCart] = React.useState<boolean>(false);

  const overviewPage = location.pathname.includes('overview');
  const checkoutPage = location.pathname.includes('checkout');

  const { scrollBottom, elementRef } = useScrollBottom();
  const [currentheight, setCurrentHeight] = React.useState<?string>();

  const [headerHeight, setHeaderHeight] = React.useState<?number>();

  const buttonRef = React.useRef<HTMLDivElement | null>(null);
  const contractRef = React.useRef<HTMLDivElement | null>(null);

  // To observe when the button container changes its height.
  const { height: buttonContainerHeight } = useResizeObserver({
    ref: buttonRef,
    box: 'border-box',
  });

  const { height: contractHeight } = useResizeObserver({
    ref: contractRef,
    box: 'border-box',
  });

  useLayoutEffect(() => {
    if (typeof document !== 'undefined') {
      const buttonContainer = document.getElementById('cartSummaryButton');
      const headerContainer = document.querySelector('[role="banner"]');

      if (buttonContainer && headerContainer) {
        setHeaderHeight(headerContainer.clientHeight);
        // 60px => Header height
        const currentHeight = `calc(100% - ${buttonContainer.clientHeight}px - ${headerContainer.clientHeight}px)`;
        setCurrentHeight(currentHeight);
      }
    }
  }, []);

  useLayoutEffect(() => {
    if (headerHeight) {
      setCurrentHeight(
        `calc(100% - ${buttonContainerHeight}px - ${headerHeight}px)`,
      );
    }
  }, [buttonContainerHeight, headerHeight, contractHeight]);

  function handleConfirmationRemove() {
    setDeleteCart(true);
  }

  function handleCancel() {
    setDeleteCart(false);
  }

  const showConfirmRemove = deleteCart && overviewPage;

  return (
    <div className={styles.cartSummaryContainer}>
      <div className={styles.cartSummarySubContainer}>
        {showConfirmRemove ? (
          <ConfirmationRemoveCart handleCancel={handleCancel} />
        ) : (
          <>
            <div
              ref={elementRef}
              style={{ height: currentheight }}
              className={styles.section}
            >
              <Total handleConfirmationRemove={handleConfirmationRemove} />
              {/* $FlowFixMe[incompatible-type] */}
              {overviewPage && <Contracts ref={contractRef} />}
            </div>
            {!checkoutPage && (
              // $FlowFixMe[incompatible-type]
              <CartSummaryButton ref={buttonRef} scrollBottom={scrollBottom} />
            )}
          </>
        )}
      </div>
    </div>
  );
}
